var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCapsuleAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2843 3.71573C17.9966 1.42809 14.2876 1.42809 12 3.71573L8.46478 7.25093C9.82313 11.1033 12.72 14.2156 16.4258 15.8585L20.2843 12C22.5719 9.71236 22.5719 6.00337 20.2843 3.71573Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2966 16.9877C11.6766 15.2271 8.81339 12.1715 7.30099 8.41473L3.71573 12C1.42809 14.2876 1.42809 17.9966 3.71573 20.2843C6.00337 22.5719 9.71236 22.5719 12 20.2843L15.2966 16.9877Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapsuleAlt);
export default __webpack_public_path__ + "static/media/capsule-alt.7421d6166a86e2df92d50854499e6b11.svg";
export { ForwardRef as ReactComponent };